// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"EducationInfo_innerContainer__24iZI","title":"EducationInfo_title__2z8Kq","imgContainer":"EducationInfo_imgContainer__XAivH","img":"EducationInfo_img__3k6wE"};